var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btraextra"},[(_vm.btra_particular)?_c('btra',{attrs:{"btra_particular":_vm.mount_btra,"btra_modulo":_vm.btra_modulo,"nopesoShow":_vm.nopesoShow},on:{"onEvent":_vm.event_btraextra},scopedSlots:_vm._u([{key:"btns_extra",fn:function({ Sitem }){return [_vm._t("btns_extra",null,{"Sitem":Sitem})]}}],null,true)}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }